// extracted by mini-css-extract-plugin
module.exports = {"postimg":"style_postimg___J4uM","verfied":"style_verfied__fZimB"};